module.exports = __webpack_public_path__ + "media/dashboard/assets/images/chat-a06542d766feaecc071c3a2b77f313e8.svg";